import Directory from "../../components/Directory/directory.component";
const Home = () => {
  return <Directory />;
};

export default Home;
